// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__OFVL2","infoBtn":"quickbooks_infoBtn__2W8mL","formBox":"quickbooks_formBox__1Htam","formFooter":"quickbooks_formFooter__1ExVX"};